/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';

import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { vaccineScheduleService } from '../../../_services/vaccine-schedule.service';
import SchedulesEmpty from './SchedulesEmpty';

const columns = [
  {
    name: 'ID',
    selector: 'scheduleId',
    sort: false,
    grow: 0
  },
  {
    name: 'Start Time',
    sort: false,
    grow: 2,
    cell: row => {
      return moment.tz(row.startTime, row.providerGroup.timezone).local().format('l LT')
    }
  },
  {
    name: 'End Time',
    sort: false,
    grow: 2,
    cell: row => {
      return moment.tz(row.endTime, row.providerGroup.timezone).local().format('l LT')
    }
  },
  {
    name: 'First Dose',
    sort: false,
    grow: 1,
    cell: row => {
      return row.firstAppointment ? moment(row.firstAppointment).format('l') : '';
    }
  },
  {
    name: 'Second Dose',
    sort: false,
    grow: 1,
    cell: row => {
      return row.secondAppointment && row.vaccineType !== "janssen" ? moment(row.secondAppointment).format('l') : '';
    }
  },
  {
    name: 'Location',
    sort: false,
    grow: 2,
    cell: row => row.providerGroup.name
  },
  {
    name: 'Provider',
    sort: false,
    grow: 2,
    cell: row => `${row.doctor.firstName} ${row.doctor.lastName}`
  },
  {
    button: true,
    sort: false,
    cell: row => {
      return <Link to={`/vaccine/schedule/${row.scheduleId}/timeslots`} className="btn btn-outline-primary">Timeslots</Link>
    }
  }
]

const DetailComponent = ({ data }) => {
  return <div className="row p-5 lead" style={{ fontSize: "medium" }}>
    <div className="col-12">
      <div className="row">
        <div className="col-3">
          <p><strong>Start Time:</strong>&nbsp;{data.startTime && moment(data.startTime).format('L LT')}</p>
        </div>
        <div className="col-3">
          <p><strong>End Time:</strong>&nbsp;{data.endTime && moment(data.endTime).format('L LT')}</p>
        </div>
        <div className="col-auto">
          <p><strong>Total To Schedule:</strong>&nbsp;{data.totalVaccine && data.totalVaccine > 0 ? data.totalVaccine : ''}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <p className="text-capitalize"><strong>Vaccine:</strong>&nbsp;{data.vaccineType && data.vaccineType}</p>
        </div>
        <div className="col-3">
          <p><strong>Location:</strong>&nbsp;{data.providerGroup.name && data.providerGroup.name}</p>
        </div>
        <div className="col-3">
          <p><strong>Provider:</strong>&nbsp;{data.doctor && `${data.doctor.firstName} ${data.doctor.lastName}`}</p>
        </div>
      </div>

      <hr />

      <div className="row">
        <div className="col-3">
          <p><strong>First Dose:</strong>&nbsp;</p>
          <p><strong>Appointment Date:</strong>&nbsp;{data.firstAppointment && moment(data.firstAppointment).format("L")}</p>
        </div>
        <div className="col-3">
          <p><strong>&nbsp;</strong>&nbsp;</p>
          <p><strong>Questionnaire:</strong>&nbsp;{data.firstQuestionnaire && data.firstQuestionnaire.title}</p>
        </div>
        <div className={data.vaccineType && data.vaccineType === "janssen" ? "d-none" : "col-3"}>
          <p><strong>Second Dose:</strong>&nbsp;</p>
          <p><strong>Appointment Date:</strong>&nbsp;{data.secondAppointment && moment(data.secondAppointment).format("L")}</p>
        </div>
        <div className={data.vaccineType && data.vaccineType === "janssen" ? "d-none" : "col-3"}>
          <p><strong>&nbsp;</strong>&nbsp;</p>
          <p><strong>Questionnaire:</strong>&nbsp;{data.secondQuestionnaire && data.secondQuestionnaire.title}</p>
        </div>
      </div>

      <hr />

      <div className="row">
        <div className="col-3">
          <p><strong>Adverse:</strong>&nbsp;</p>
          <p><strong>Complete By:</strong>&nbsp;{data.adverseCompleteBy && moment(data.adverseCompleteBy).format("L")}</p>
        </div>
        <div className="col-3">
          <p><strong>&nbsp;</strong>&nbsp;</p>
          <p><strong>Questionnaire:</strong>&nbsp;{data.adverseQuestionnaire && data.adverseQuestionnaire.title}</p>
        </div>
        <div className="col-3">
          <p><strong>&nbsp;</strong>&nbsp;</p>
          <p><strong>Location:</strong>&nbsp;{data.adverseProviderGroup && data.adverseProviderGroup.name}</p>
        </div>
        <div className="col-3">
          <p><strong>&nbsp;</strong>&nbsp;</p>
          <p><strong>Provider:</strong>&nbsp;{data.adverseDoctor && `${data.adverseDoctor.firstName} ${data.adverseDoctor.lastName}`}</p>
        </div>
      </div>

      <hr />

      {data.scheduleGroup && <>
        <div className="row">
          <div className="col">
            <p><strong>Groups:</strong></p>
          </div>
          <div className="col">
            <p><strong>To Schedule:</strong></p>
          </div>
        </div>

        {data.scheduleGroup.data.map((group, groupIndex) => {
          return <div className="row" key={groupIndex}>
            <div className="col">
              <p key={`group_${groupIndex}`}>{group.name}</p>
            </div>
            <div className="col">
              <p key={`count_${groupIndex}`}>{group.count}</p>
            </div>
          </div>
        })}
      </>
      }

    </div>
  </div>
}

export default function ListSchedule() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [initLoad, setInitLoad] = useState(true)
  const [collection, setCollection] = useState([]);

  useEffect(() => {
    setLoading(true);

    vaccineScheduleService.all()
      .then((data) => {
        setLoading(false);
        setInitLoad(false);
        setCollection(data);
      })
      .catch(() => {
        setLoading(false);
        dispatch(alertActions.error('Could not load schedule at this time. Please try again later.'));
      })
  }, []);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active" aria-current="page">Mass Schedule</li>
      </ol>
    </nav>

    {initLoad && loading ?
      <Spinner animation="border" role="status" />
      :
      initLoad && collection.length === 0 ?
        <SchedulesEmpty />
        :
        <DataTable
          title="List of created mass schedule"
          actions={<Link to="/vaccine/schedule/create" className="btn btn-primary">Create Mass Schdedule</Link>}
          columns={columns}
          data={collection}
          progressPending={loading}
          striped={true}
          pagination={true}
          paginationServer={true}
          paginationTotalRows={2}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={15}
          expandableRows
          expandOnRowClicked
          expandableRowsComponent={<DetailComponent />}
          customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
        />
    }
  </div>
}